import React from "react";
import { Button, Modal } from "react-bootstrap";
import { IoMdAdd } from "react-icons/io";
import { MdDeleteForever } from "react-icons/md";
import { MdVideoFile } from "react-icons/md";

const GlobalVideoUploadModal = ({
  show, onHide, videoInputRef, videos,
  onVideoAdd, onVideoRemove, onUpload,
  formattedDate, hearingLabel,
}) => (
  <Modal show={show} onHide={onHide} centered>
    <Modal.Header closeButton className="customModal">
      <Modal.Title className="mx-auto">Upload Hearing Videos</Modal.Title>
    </Modal.Header>

    <Modal.Body style={{ padding: "1.5rem" }}>
      <p className="text-muted mb-4" style={{ fontSize: "0.875rem" }}>
        Videos will be saved for all cases in this{" "}
        <strong style={{ textTransform: "capitalize" }}>{hearingLabel}</strong> hearing session
        on <strong>{formattedDate}</strong>.
      </p>

      {/* Drop zone / select area */}
      <div
        onClick={() => videoInputRef.current.click()}
        style={{
          border: "2px dashed #ccc",
          borderRadius: "10px",
          padding: "1.5rem",
          textAlign: "center",
          cursor: "pointer",
          background: "#fafafa",
          transition: "border-color 0.2s",
        }}
        onMouseEnter={e => e.currentTarget.style.borderColor = "#f0a500"}
        onMouseLeave={e => e.currentTarget.style.borderColor = "#ccc"}
      >
        <IoMdAdd style={{ fontSize: "2rem", color: "#f0a500", marginBottom: "0.4rem" }} />
        <p style={{ margin: 0, fontSize: "0.875rem", color: "#555" }}>
          Click to select video files
        </p>
        <p style={{ margin: 0, fontSize: "0.75rem", color: "#aaa" }}>
          MP4, AVI, MOV, MKV and other video formats
        </p>
        <input
          type="file"
          ref={videoInputRef}
          accept="video/*"
          multiple
          style={{ display: "none" }}
          onChange={onVideoAdd}
        />
      </div>

      {/* Selected files list */}
      {videos.length > 0 && (
        <div style={{ marginTop: "1rem" }}>
          <p style={{ fontSize: "0.8rem", color: "#555", marginBottom: "0.5rem", fontWeight: 600 }}>
            Selected ({videos.length})
          </p>
          <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
            {videos.map((video, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "0.75rem",
                  padding: "0.5rem 0.75rem",
                  background: "#f5f5f5",
                  borderRadius: "8px",
                  fontSize: "0.825rem",
                }}
              >
                <MdVideoFile style={{ fontSize: "1.3rem", color: "#f0a500", flexShrink: 0 }} />
                <span style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {video.name}
                </span>
                <span style={{ color: "#aaa", fontSize: "0.75rem", flexShrink: 0 }}>
                  {(video.size / (1024 * 1024)).toFixed(1)} MB
                </span>
                <button
                  type="button"
                  onClick={() => onVideoRemove(index)}
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    padding: "2px",
                    color: "#e74c3c",
                    flexShrink: 0,
                    display: "flex",
                    alignItems: "center",
                  }}
                  title="Remove"
                >
                  <MdDeleteForever style={{ fontSize: "1.25rem" }} />
                </button>
              </div>
            ))}
          </div>
        </div>
      )}
    </Modal.Body>

    <Modal.Footer className="d-flex justify-content-center gap-2" style={{ borderTop: "1px solid #eee" }}>
      <Button onClick={onUpload} className="custBtn" disabled={videos.length === 0}>
        Upload{videos.length > 0 ? ` (${videos.length})` : ""}
      </Button>
      <Button onClick={onHide} className="custBtn">Close</Button>
    </Modal.Footer>
  </Modal>
);

export default GlobalVideoUploadModal;
